import type { Category } from '../types';

interface CategoryFilterProps {
  selected: Category | 'all';
  onSelect: (category: Category | 'all') => void;
}

interface CategoryOption {
  label: string;
  value: Category | 'all';
}

const categories: CategoryOption[] = [
  { label: '全部', value: 'all' },
  { label: '获客', value: 'acquisition' },
  { label: '管理', value: 'management' },
  { label: '内容', value: 'content' },
  { label: '自动化', value: 'automation' },
];

export function CategoryFilter({ selected, onSelect }: CategoryFilterProps): JSX.Element {
  return (
    <div
      className="no-scrollbar"
      style={{
        display: 'flex',
        gap: '8px',
        overflowX: 'auto',
        padding: '8px 0',
        whiteSpace: 'nowrap',
      }}
    >
      {categories.map((cat) => {
        const isActive = selected === cat.value;
        return (
          <button
            key={cat.value}
            onClick={() => onSelect(cat.value)}
            style={{
              padding: '6px 14px',
              borderRadius: '8px',
              border: isActive ? '1px solid rgba(0, 0, 0, 0.15)' : '1px solid rgba(0, 0, 0, 0.06)',
              fontSize: '12px',
              fontWeight: isActive ? 500 : 400,
              cursor: 'pointer',
              flexShrink: 0,
              backgroundColor: isActive ? 'rgba(0, 0, 0, 0.04)' : '#ffffff',
              color: isActive ? '#1a1a1c' : '#a1a1a6',
              transition: 'all 0.3s cubic-bezier(0.22, 1, 0.36, 1)',
              letterSpacing: '0.04em',
            }}
          >
            {cat.label}
          </button>
        );
      })}
    </div>
  );
}
